// Assumes centimeters and kilograms.
export const getBMI = (height, weight, heightUnit = "cm") => {
  if (heightUnit === "m") {
    height = height * 100;
  }
  const bmi = weight / (height / 100) ** 2;
  return Math.round(bmi * 100) / 100;
};

export const getWeightFromBmi = (height, bmi) => {
  const kgPerPound = 2.2;
  return Math.floor((height / 100) ** 2 * bmi * kgPerPound);
};
